import CryptoJS from 'crypto-js'

import Token from './token'
import { jwtSecret } from '../../api/toya/apiConstantsCodespot'

const base64url = (source: CryptoJS.lib.WordArray) => {
    // Encode in classical base64
    let encodedSource = CryptoJS.enc.Base64.stringify(source)

    // Remove padding equal characters
    encodedSource = encodedSource.replace(/=+$/, '')

    // Replace characters according to base64url specifications
    encodedSource = encodedSource.replace(/\+/g, '-')
    encodedSource = encodedSource.replace(/\//g, '_')
    return encodedSource
}

export const generateJwt = (
    headersStringified: string,
    loginPayloadStringified: string,
    exp: number
) => {
    // header
    const stringifiedHeader = CryptoJS.enc.Utf8.parse(headersStringified)
    const encodedHeader = base64url(stringifiedHeader)

    // data
    const stringifiedData = CryptoJS.enc.Utf8.parse(loginPayloadStringified)
    const encodedData = base64url(stringifiedData)
    const token = `${encodedHeader}.${encodedData}`

    const encodedSecret = CryptoJS.enc.Base64.parse(jwtSecret)

    //singing token
    let signature: CryptoJS.lib.WordArray | string = CryptoJS.HmacSHA256(
        token,
        encodedSecret
    )
    signature = base64url(signature)
    const signedToken = `${token}.${signature}`
    const loginToken = new Token(signedToken, exp)
    return loginToken
}
